module.exports = __webpack_public_path__ + "static/media/bienetre.0b1e0e15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bienetre.jpg
// module id = 1161
// module chunks = 0